import api from "./axios";

export const basicInfo = async (payload) => {
  const response = await api.post(
    "/users/onboarding/save-basic-info/",
    payload,
  );

  return response.data.data;
};

export const physicalMerital = async (payload) => {
  const response = await api.patch(
    "/users/onboarding/update-physical-marital-status/",
    payload,
  );

  return response?.data?.data;
};

export const careerDetails = async (payload) => {
  const response = await api.patch(
    "/users/onboarding/save-career-details/",
    payload,
  );

  return response?.data?.data;
};

export const partnerPreference = async (payload) => {
  const response = await api.patch(
    "/users/onboarding/save-partner-preference/",
    payload,
  );

  return response?.data?.data;
};

export const uploadPhoto = async (payload) => {
  const response = await api.post(
    "/users/onboarding/update-user-photo/",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const onboardingDetails = async ({ step }) => {
  const response = await api.get("/users/onboarding/onboarding-details/", {
    params: { step },
    headers: {
      "X-Platform": "1",
    },
  });

  return response.data.data;
};

export const reportProfile = async (payload) => {
  const response = await api.post("/users/report-profile/", payload);
  return response.data.data;
};

export const blockProfile = async (payload) => {
  const response = await api.post("/users/block-profile/", payload);
  return response.data.data;
};
